import React from 'react';
import { motion } from 'framer-motion';
export const ProblemSection = () => {
  return <section id="problem" className="py-24 bg-white" data-id="element-107">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-109">
          <h2 className="text-3xl md:text-5xl font-bold text-primary mb-8 leading-tight" data-id="element-110">
            ¿Sentís que sabés lo que tenés que hacer, pero algo más fuerte te
            detiene?
          </h2>

          <p className="text-lg md:text-xl text-primary/80 mb-12 leading-relaxed" data-id="element-111">
            Pasaste años en terapia charlando sobre tus problemas. Leíste mil
            libros. Conocés el origen de tu trauma... pero el nudo en el
            estómago sigue ahí. Eso pasa porque estás intentando cambiar un{' '}
            <strong data-id="element-112">95% de programación subconsciente</strong> con solo un 5% de
            voluntad consciente.
          </p>

          <div className="relative p-8 md:p-10 bg-soft/20 rounded-2xl border-l-4 border-accent" data-id="element-113">
            <div className="absolute -top-4 -left-4 text-6xl text-accent/20 font-serif" data-id="element-114">
              "
            </div>
            <p className="text-xl md:text-2xl font-semibold text-primary leading-relaxed relative z-10" data-id="element-115">
              En La Conexión Cuántica no vamos a escuchar tu historia otra vez y
              revivir las experiencias pasadas con tediosas sesiones
              interminables. Aquí vamos a cambiar lo que genera tu malestar
              yendo a tu subconsciente, quitando los bloqueos y traumas que te
              impiden vivir como mereces.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};